import React from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColumnMenu } from "@mui/x-data-grid";

function CustomColumnMenu(props) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
      }}
    />
  );
}

function Revenu({ tableData, date, dialogOpen, mode, setDialogTitle }) {
//   const modifiedData = tableData?.map((item) => ({  ...item, amount: Math.trunc(Number(item.amount)).toLocaleString("en-IN"), }));

  
  const columns = [
    // {
    //     field: "Id",
    //     editable: false,
    //     sortable: false,
    //     flex: 1.5,
    //     // renderHeader: (params) => <b>{date}</b>,
    //   },
    {
      field: "Name",
      editable: false,
      sortable: false,
      
      // flex: 1,
    //   renderHeader: (params) => <b>{date}</b>,
    },

    {
      field: "Count",
      editable: false,
      sortable: false,
      // flex: 1,
      align: "right",
      headerAlign: "right",
    //   renderHeader: (params) => <b>Bills</b>,
    },

    {
      field: "Revenu",
      headerName: "Value",
      editable: false,
      sortable: false,
      // flex: 1,
      align: "right",
      headerAlign: "right",
    //   renderHeader: (params) => <b>Value</b>,
    },

    // { field: 'perc', headerName: '%', editable: false, sortable: false, flex: 1, align: 'right', headerAlign: 'right'}
  ];

  const rows = [

    { Name: 'Estimate',  Count:'', Revenu:''},
    { Name: 'Job Card',  Count:'', Revenu:''},
    { Name: 'Invoice',  Count:'', Revenu:''},
    { Name: 'Cash Job',  Count:'', Revenu:''},
    ];

  return (
    <div>
      <Box
        sx={{
          m: "0 20px 20px 20px",
          // height: '175px',
          "& .MuiDataGrid-root": {
            backgroundColor: "white",
            fontSize: "12px",
            border: "none",
          },

          "& .MuiDataGrid-columnHeaders": {
            // backgroundColor: '#489C8F',
            // color: 'white',
            fontSize: "18px",
            
          },

          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <DataGrid
          columnHeaderHeight={45}
          rowHeight={40}
          hideFooter={true}
          rows={rows}
          columns={columns}
          getRowId={(row) => row.Name}
          
          // getRowId={(row) => generateRandom()}

        //   onRowClick={(params) => {
        //     dialogOpen(params.row.departmentName, mode);
        //     setDialogTitle(params.row.departmentName);
        //   }}
          disableRowSelectionOnClick
          // disableColumnMenu

          slots={{ columnMenu: CustomColumnMenu }}
          // initialState={{

          //     pagination: {

          //         paginationModel: {

          //             pageSize: 10,

          //         },

          //     },

          // }}

          // pageSizeOptions={[10]}

          autoHeight={true}
        />
      </Box>
    </div>
  );
}
export default Revenu;
